import React from "react";
import { Link } from "react-router-dom";
import AddToolTip from "../AddToolTip";
import { get } from "lodash";
const SponsorCard = (props) => {
  return (
    <div className="Sponsor-Card">
      {props.type == "img" ? (
        <div style={{ padding: "1.875rem 0rem 1.875rem 1.25rem" }}>
          <img
            src={props.image}
            style={{ width: "6.438rem", height: "2rem" }}
          />
        </div>
      ) : null}
      <p className="title">{props.title}</p>
      {props.type == "link" ? (
        <p className="value">
          <Link onClick={props.onClick}>{props.value}</Link>
        </p>
      ) : get(props, "value", "")?.toString()?.length > 20 ? (
        <AddToolTip
          name={props.value}
          style={{ maxWidth: "200px" }}
          className="value"
        >
          {props.value}
        </AddToolTip>
      ) : (
        <p className="value">{props.value}</p>
      )}
    </div>
  );
};

export default SponsorCard;
